import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import UserSearch from '../../components/UserSearch/UserSearch';
import { devices } from '../../const/devices';
import { useIsTablet } from '../../hooks/useBreakpoint';

const StyledSearchWrapper = styled.div`
	width: 100%;
	padding-right: 1rem;

	@media ${devices.tablet} {
		padding-right: 0;
	}
`;

export const Search = () => {
	const navigate = useNavigate();
	const isTablet = useIsTablet();

	useEffect(() => {
		if (!isTablet) {
			navigate('/');
		}
	}, [isTablet]);

	if (!isTablet) {
		return null;
	}

	return (
		<StyledSearchWrapper>
			<UserSearch isSearchPage />
		</StyledSearchWrapper>
	);
};
